import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

const resource = resources.FacturacionGuia;


export class FacturaPublicoGeneralList extends React.PureComponent {

    canitdadGuiasAFacturar = observeResource(resource.CantidadGuiasAFacturar);

    render() {
        return (
            <FacturaPublicoGeneraComp cantidad={this.canitdadGuiasAFacturar} permisos={resources.User.PermisoRx} />
        )
    }
}

interface Props {
    cantidad: number;
    permisos: models.Rol;
}

class FacturaPublicoGeneraCompNoRx extends React.PureComponent<Props> {

    cantidad = (x: Props) => x.cantidad;
    verBotonFacturar = (x: Props) => x.permisos.Facturas.VerBotonFacturarGuiaPublicoGenerarTimbrar;
    verBotonFacturarSinTimbrar = (x: Props) => x.permisos.Facturas.VerBotonFacturarGuiaPublicoGenerarSinTimbrar;

    onFacturarGuias = async () => {
        if (await kea.yesno("¿Facturar guias de público general?")) {
            await resource.FacturarGuiasPublicoSinTimbrar();
        }
    }

    onFacturarGuiasTimbrar = async () => {
        if (await kea.yesno("¿Facturar guias de público general?")) {
            await resource.FacturarGuiasPublico();
        }
    }

    onFacturarGuiasEAD = async () => {
        if (await kea.yesno("¿Facturar guias de EAD?")) {
            await resource.FacturarGuiasEADContadoFXCSinTimbrar();
        }
    }

    onFacturarGuiasTimbrarEAD = async () => {
        if (await kea.yesno("¿Facturar guias de EAD?")) {
            await resource.FacturarGuiasEADContadoFXC();
        }
    }

    onRegresar = () => history.go('../');
    render() {
        const verBotonSintimbrar = this.verBotonFacturarSinTimbrar(this.props);
        const verBotonTimbrando = this.verBotonFacturar(this.props);
        return (
            <div>
                <kea.Title titulo="Facturar guías de público general" onRegresar={this.onRegresar} >
                    {
                        verBotonTimbrando &&
                        <kea.Button style="success" children="Facturar y timbrar todas las guías" onClick={this.onFacturarGuiasTimbrar} />
                    }
                    {
                        verBotonSintimbrar &&
                        <kea.Button style="primary" children="Facturar sin timbrar todas las guías" onClick={this.onFacturarGuias} />
                    }
                    {
                        verBotonTimbrando &&
                        <kea.Button style="success" children="Facturar y timbrar guias de EAD de FXC de contado" onClick={this.onFacturarGuiasTimbrarEAD} />
                    }
                    {
                        verBotonSintimbrar &&
                        <kea.Button style="primary" children="Facturar sin timbrar guias de EAD de FXC de contado" onClick={this.onFacturarGuiasEAD} />
                    }
                </kea.Title>

                <div className="alert alert-warning">
                    <label>Este proceso es automático</label>
                    <hr />
                    El proceso de facturación a publico general se ejecuta todos los dias a las 23:50, pero es posible ejecutarlo manualmente dando click en <b>Facturar todas las guias</b>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        Cantidad de guías a facturar: <label>{this.cantidad(this.props)}</label>
                    </div>
                </div>
            </div>
        )
    }
}

const FacturaPublicoGeneraComp = componentToRx(FacturaPublicoGeneraCompNoRx);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturapublico/list/list.tsx